const HubHttpBaseClient = {
  export() {
    throw new Error('Please override the `export` function with your own implementation.');
  }
};
export default HubHttpBaseClient;